import {
  Row,
  Col,
  Form,
  Input,
  Select,
  InputNumber,
  Badge,
  Card,
  Button,
  Spin,
} from "antd";

import {
  ROOM_CAPACITY_TYPES,
  OTA_SERVICE_TYPE,
  colProps,
} from "../../../constants/constent";
import { useEffect, useState } from "react";
import { EDIT_VENDOR_ROOMS } from "../../../constants/api";
import { displayMessage, postAPI } from "../../../utils/common";
import {
  ERROR_MSG_TYPE,
  SUBFAILED,
  SUCCESS_MSG_TYPE,
} from "../../../constants/messages";

function VendorHotelRoomsTab({
  facility,
  edit_id,
  handleTabChange,
  vendor,
  fetchVendorDetail,
}) {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    if (!vendor) return;

    form.setFieldsValue({
      rooms: vendor.rooms.map((item) => {
        return {
          ...item,
          facilities: item.facilities?.map((e) => e.facilities_id) || [],
        };
      }),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendor]);

  /* ================= HANDLERS ================= */

  const onSubmit = (values) => {
    const payload = {
      ...values,
      vendor_id: vendor.id,
    };
    console.log("On Submit the Vendor Hotel Romms Form : ", payload);
    postAPI(
      EDIT_VENDOR_ROOMS,
      payload,
      (res) => {
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
          fetchVendorDetail();
          handleTabChange("1");
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, SUBFAILED);
      },
    );
  };
  /* ================= JSX ================= */
  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.List name="rooms">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name }) => (
                <Badge.Ribbon
                  text={
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => remove(name)}
                    >
                      Remove
                    </span>
                  }
                  color="red"
                >
                  <Card
                    key={key}
                    title={`Room ${name + 1}`}
                    style={{ marginBottom: 20 }}
                  >
                    <Row gutter={[16, 16]}>
                      <Form.Item name={[name, "id"]} />
                      <Col {...colProps}>
                        <Form.Item
                          name={[name, "room_name"]}
                          label="Room Name"
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col {...colProps}>
                        <Form.Item
                          name={[name, "room_qty"]}
                          label="Room Qty"
                          rules={[{ required: true }]}
                        >
                          <InputNumber min={1} style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>

                      <Col {...colProps}>
                        <Form.Item
                          name={[name, "max_guests"]}
                          label="Max Guests"
                          rules={[{ required: true }]}
                        >
                          <InputNumber min={1} style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>

                      <Col {...colProps}>
                        <Form.Item
                          name={[name, "room_rate"]}
                          label="Room Rate"
                          rules={[{ required: true }]}
                        >
                          <InputNumber min={0} style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>

                      <Col {...colProps}>
                        <Form.Item
                          name={[name, "extra_adult_rate"]}
                          label="Extra Adult Rate"
                        >
                          <InputNumber min={0} style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>

                      <Col {...colProps}>
                        <Form.Item
                          name={[name, "room_numbers"]}
                          label="Room Numbers"
                        >
                          <Input placeholder="101,102,103" />
                        </Form.Item>
                      </Col>

                      <Col {...colProps}>
                        <Form.Item
                          name={[name, "facilities"]}
                          label="Facilities"
                        >
                          <Select
                            placeholder="Select"
                            mode="multiple"
                            options={
                              facility &&
                              facility.map((e) => ({
                                value: e.id,
                                label: e.title,
                              }))
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* Rate Types */}
                    <Form.List name={[name, "rate_types"]}>
                      {(rateFields, { add, remove }) => (
                        <>
                          {rateFields.map(({ key, name: rateName }) => (
                            <Badge.Ribbon
                              text={
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => remove(rateName)}
                                >
                                  Remove
                                </span>
                              }
                              color="red"
                            >
                              <Row gutter={[16, 16]} key={key}>
                                <Col {...colProps}>
                                  <Form.Item
                                    name={[rateName, "room_code"]}
                                    label="Room Code"
                                    rules={[{ required: true }]}
                                  >
                                    <Input />
                                  </Form.Item>
                                </Col>

                                <Col {...colProps}>
                                  <Form.Item
                                    name={[rateName, "room_type"]}
                                    label="Room Type"
                                    rules={[{ required: true }]}
                                  >
                                    <Select
                                      placeholder="Select"
                                      options={ROOM_CAPACITY_TYPES}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col {...colProps}>
                                  <Form.Item
                                    name={[rateName, "room_service"]}
                                    label="Room Service"
                                    rules={[{ required: true }]}
                                  >
                                    <Select
                                      placeholder="Select"
                                      options={OTA_SERVICE_TYPE}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Badge.Ribbon>
                          ))}

                          <Button type="dashed" onClick={() => add()} block>
                            + Add Rate Type
                          </Button>
                        </>
                      )}
                    </Form.List>
                  </Card>
                </Badge.Ribbon>
              ))}

              <Button type="dashed" onClick={() => add()} block>
                + Add Room
              </Button>
            </>
          )}
        </Form.List>
        <Row spceber>
          <Col span={24}>
            <Form.Item
              style={{ float: "right", marginTop: 20 }}
              label=""
              colon={false}
            >
              <Button loading={loading} block htmlType="submit">
                {edit_id ? "Update" : "Submit"}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
}
export default VendorHotelRoomsTab;
